// extracted by mini-css-extract-plugin
export default {"openSelectionList":"openSelectionList_k2YLi","cellWithIcon":"cellWithIcon_z7vPx","icon":"icon_Wz99l"};